export const getBasePath = (): string => {
  const protocol = window.location.protocol;
  const host = window.location.host;

  if (host.includes('localhost')) {
    const backendHostname = import.meta.env.VITE_LOCALHOST_BACKEND_HOSTNAME;
    return `http://${backendHostname}/`;
  } else {
    return `${protocol}//${host}/`;
  }
};
